import { z } from 'zod';
import { AuditSchema } from './../settings/audit-schema';

export const SettlementReasonSchema = z.enum([
  'resignation',       // Renuncia
  'dismissal',         // Despido
  'contract_end',      // Fin de contrato
  'retirement',        // Jubilación
  'other',
]);

export const LaborSettlementSchema = z.object({
  employeeId: z.string(),
  employeeName: z.string(),
  businessId: z.string(),
  
  // Período Laboral
  hiringDate: z.coerce.date(),
  terminationDate: z.coerce.date(),
  yearsOfService: z.number(),
  
  reason: SettlementReasonSchema.default('resignation'),

  // Cálculo de Prestaciones (Venezuela)
  calculations: z.object({
    accruedAntiquity: z.number(),      // Prestaciones sociales (Antigüedad - Art 142)
    unpaidSalaries: z.number(),        // Sueldos pendientes
    fractionalVacations: z.number(),   // Vacaciones fraccionadas
    fractionalVacationBonus: z.number(), // Bono vacacional fraccionado
    fractionalChristmasBonus: z.number(), // Utilidades fraccionadas
    statutoryIndemnity: z.number().default(0), // Indemnización por despido injustificado (Art 92)
  }),

  totalAmount: z.number(),
  currency: z.enum(['USD', 'BS', 'EUR']).default('BS'),
  
  status: z.enum(['pending', 'approved', 'paid']).default('pending'),
  
  audit: AuditSchema,
});

export type LaborSettlement = z.infer<typeof LaborSettlementSchema>;
export type LaborSettlementWithId = LaborSettlement & { id: string };
